const scope = "issuerCounts";
export default scope;
